import Chartkick from "chartkick"

const locale = document.querySelector('html').lang
Chartkick.configure({language: locale, mapsApiKey: "AIzaSyBJSsfEwQzYOOgvk6zpZIwGu2cDILHnSLc"})
